<template>
  <el-dialog
    ref="merchantdetal"
    width="70%"
    :title="title"
    :visible.sync="visible"
    v-loading="loading"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="路线名称:">
        <tempalte>
          {{ ruleForm.lineName }}
        </tempalte>
      </el-form-item>
      <el-form-item label="通知号码:">
        <tempalte>
          {{ ruleForm.notifyPhone }}
        </tempalte>
      </el-form-item>
      <el-form-item label="站点规则:">
        <el-table
          :data="ruleForm.tableData"
          :span-method="objectSpanMethod"
          border
          style="width: 95%; margin-top: 30px"
        >
          <el-table-column type="index" label="序号" align="center" width="70" />
          <el-table-column prop="type" label="类型" align="center" />
          <el-table-column
            :show-overflow-tooltip="true"
            prop="stationName"
            label="站点名称"
            align="center"
            width="150"
          />
          <el-table-column prop="rule" label="上下车规则" align="center" />
          <el-table-column
            :show-overflow-tooltip="true"
            prop="startSellTimeStr"
            label="起售时间"
            align="center"
          />
          <el-table-column prop="endSellTimeStr" label="停售时间" align="center" />
          <el-table-column prop="pickUpType" label="接送类型" align="center" />
          <el-table-column prop="pickUpType" label="自动推单时间(距发车时间)" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.pushTime">{{ scope.row.pushTimeStr }}</span>
              <span v-else>———</span>
            </template>
          </el-table-column>
          <el-table-column prop="openPickUp" label="是否开启接送" align="center" width="110" />
          <el-table-column prop="openGoOwn" label="自行前往车场" align="center" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.isShow === 1">{{
                scope.row.openGoOwn === 1 ? '开启' : '关闭'
              }}</span>
              <span v-else>———</span>
            </template>
          </el-table-column>
          <el-table-column prop="isShow" label="是否发车点" align="center" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.isShow === 1 ? '是' : '否' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="pickUpRuleStr" label="接送规则" width="150" align="center">
            <template slot-scope="scope">
              <span
                style="color: #1890ff"
                @click="ruleDetal(scope.$index, scope.row)"
                v-if="scope.row.openPickUp === '开启'"
                >{{ scope.row.pickUpRuleStr }}</span
              >
              <span v-else>———</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="接人时间" align="center" width="180">
						<template slot-scope="scope" v-if="scope.row.openPickUp === '开启' && scope.row.pickUpType === '接人'">
							<span>提前 {{scope.row.pickUpTime}} 分钟接人</span>
						</template>
					</el-table-column> -->
        </el-table>
      </el-form-item>
      <el-form-item label="价格方案:">
        <el-table
          :data="ruleForm.priceList"
          :span-method="objectSpanMethod"
          border
          style="width: 70%; margin-top: 30px"
        >
          <el-table-column type="index" label="序号" align="center" width="80" />
          <el-table-column
            :show-overflow-tooltip="true"
            prop="name"
            label="价格方案名称"
            align="center"
            width="180"
          />
          <el-table-column prop="carTypeLevel" label="车型等级" align="center" />
          <el-table-column prop="carSeatNumb" label="车座" align="center" />
          <el-table-column prop="choiceSeat" label="选座" align="center" />
          <el-table-column prop="ticketType" label="票价模式" align="center" />
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" @click="orderDetal(scope.row)">预览</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <!-- <el-form-item label="双码上传:">
				<template>
					<div v-if="ruleForm.isDoubleCode === 0">否</div>
					<div v-if="ruleForm.isDoubleCode === 1">是</div>
				</template>
			</el-form-item> -->
      <el-form-item label="备注:">
        <template>
          {{ ruleForm.remark }}
        </template>
      </el-form-item>
      <el-form-item label="推荐线路" v-has-permi="['recommend_line']" />
      <el-form-item label="线路：" v-has-permi="['recommend_line']">
        <div class="flex margin-bottom-10" v-for="(item, index) in recommendLineList" :key="index">
          <el-select
            v-model="item.lineId"
            placeholder="请选择线路"
            clearable
            filterable
            disabled
            style="width: 50%"
          >
            <el-option
              v-for="it in lineList"
              :key="it.lineId"
              :label="it.lineName"
              :value="it.lineId"
              :disabled="it.disabled"
            />
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="推荐方式：" v-has-permi="['recommend_line']">
        <span>{{ recommendType === 1 ? '仅起点终点推荐线路' : '区间推荐线路' }}</span>
      </el-form-item>
    </el-form>
    <boundmerchant-price ref="merchantPrice" v-if="showDialog" />
    <boundmerchant-RuleDetal ref="merchantRuleDetal" v-if="ruleDialog" />
    <el-button
      style="margin: 20px 0 10px 0"
      @click="showLogData"
      :loading="logLoading"
      size="small"
      type="primary"
      >操作日志
      <i class="el-icon-arrow-right" v-if="!showLog"></i>
      <i class="el-icon-arrow-down" v-else></i>
    </el-button>
    <transition name="el-fade-in-linear">
      <operation-log :list="logList" v-show="showLog" />
    </transition>
  </el-dialog>
</template>

<script>
  import { queryMerchantPriceDetail } from '@/api/transport/boundmerchant'
  import { getLog } from '@/api/common'
  import boundmerchantPrice from './boundmerchant-price'
  import boundmerchantRuleDetal from './boundmerchant-ruleDetal'
  import OperationLog from '@/components/log-info/list'
  export default {
    components: { boundmerchantPrice, OperationLog, boundmerchantRuleDetal },
    data() {
      return {
        ruleDialog: false,
        showDialog: false,
        visible: false,
        title: '',
        ruleForm: {
          lineName: '',
          notifyPhone: '',
          tableData: [],
          priceList: [],
          // isDoubleCode:0,
          remark: ''
        },
        logList: [],
        logLoading: false,
        showLog: false,
        now: {},
        recommendLineList: [
          {
            lineId: ''
          }
        ],
        recommendType: 1,
        lineList: [],
        loading: false
      }
    },
    methods: {
      showLogData() {
        this.showLog = !this.showLog
        /* if (this.logList.length > 0) {
          return
        }
        this.getLogData() */
      },
      async getLogData() {
        this.logLoading = true
        const { code, data } = await getLog({
          bizLinkId: this.now.id,
          type: 4
        })
        this.logLoading = false
        if (code === 0) {
          this.logList = data
        }
      },
      //
      edit(row) {
        this.lineList = row.lineList
        this.visible = true
        this.title = row.merchantName
        // this.getPriceList(row.id)
        this.getOrderInfo(row.id)
        this.now = row
        this.getLogData()
      },
      // 接送规则预览
      ruleDetal(index, row) {
        row.addMerchantPriceStationRuleAreaVoList.forEach((item) => {
          item.isOpen = true
        })
        this.ruleDialog = true
        this.$nextTick(() => {
          this.$refs.merchantRuleDetal.edit(row)
        })
      },

      // 根据供应商查价格方案
      orderDetal(row) {
        this.showDialog = true
        this.$nextTick(() => {
          this.$refs.merchantPrice.edit(row)
        })
      },
      getOrderInfo(id) {
        this.loading = true
        queryMerchantPriceDetail(id)
          .then((res) => {
            const { code, data } = res
            if (code !== 0) {
              return
            }
            const { recommendLineId, recommendType } = data.addMerchantPriceStationRuleVo
            this.recommendType = recommendType
            const selectedList = recommendLineId.split(',')
            this.recommendLineList = selectedList.map((it) => {
              return {
                lineId: it
              }
            })

            // this.ruleForm.isDoubleCode = res.data.isDoubleCode
            this.ruleForm.lineName = res.data.lineName
            this.ruleForm.remark = res.data.remark
            this.ruleForm.notifyPhone = res.data.notifyPhone
            res.data.addMerchantPriceStationRuleVo.addMerchantPriceStationRuleTypeVoList.forEach(
              (item, index) => {
                item.index = index + 1
                if (index === 0) {
                  item.type = '起点'
                } else if (
                  index ===
                  res.data.addMerchantPriceStationRuleVo.addMerchantPriceStationRuleTypeVoList
                    .length -
                    1
                ) {
                  item.type = '终点'
                } else {
                  item.type = '经过'
                }
                switch (item.rule) {
                  case 1:
                    item.rule = '上车'
                    break
                  case 2:
                    item.rule = '下车'
                    break
                  case 3:
                    item.rule = '上下车'
                    break
                }
                // eslint-disable-next-line eqeqeq
                if (item.pickUpType == 1) {
                  item.pickUpType = '接人'
                  // eslint-disable-next-line eqeqeq
                } else if (item.pickUpType == 2) {
                  item.pickUpType = '送人'
                } else {
                  item.pickUpType = '-'
                }
                if (item.openPickUp === 1) {
                  item.openPickUp = '开启'
                  // eslint-disable-next-line eqeqeq
                } else if (item.openPickUp == 2) {
                  item.openPickUp = '关闭'
                }
                if (item.pickUpRule === 1) {
                  item.pickUpRule = '摆渡车接送'
                } else if (item.pickUpRule === 2) {
                  item.pickUpRule = '城际车接送'
                }
              }
            )
            this.ruleForm.tableData =
              res.data.addMerchantPriceStationRuleVo.addMerchantPriceStationRuleTypeVoList

            res.data.merchantPriceMethodVoList.forEach((obj) => {
              if (obj.ticketType === 1) {
                obj.ticketType = '统一价'
              } else if (obj.ticketType === 2) {
                obj.ticketType = '按座位定价'
              }
              if (obj.choiceSeat === 1) {
                obj.choiceSeat = '支持'
              } else if (obj.choiceSeat === 2) {
                obj.choiceSeat = '不支持'
              }
            })
            this.ruleForm.priceList = res.data.merchantPriceMethodVoList
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>

<style scoped></style>
